// extracted by mini-css-extract-plugin
export default {"root":"KeJkjJ","image":"yQNxE5","scroller":"ZDTmVC"};